module.exports = __webpack_public_path__ + "media/images/icon-dropdown-white-3a35cda2f4e0bf074220be47766d4bc9.svg";